import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_4 = { class: "d-flex justify-content-between flex-wrap gap-3" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "py-sm-1 d-block" }
const _hoisted_9 = { class: "table-content" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "d-flex gap-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "modal fade",
  id: "modalImport",
  tabindex: "-1",
  "aria-labelledby": "modalImportLabel",
  "aria-hidden": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_16 = { class: "modal-dialog" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "position-relative" }

import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { onMounted, ref, watch } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import ItemFilter from "./ItemFilter.vue";
import { useField, useForm } from "vee-validate";
import ExcelUploader from "@/components/Common/ExcelUploader.vue";
import CustomSizeLoading from "@/components/Common/CustomSizeLoading.vue";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import axios from "axios";
import { hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListItem',
  setup(__props) {

const linkAdd = {
  text: "Add Goods/Item",
  url: "/management/item/create",
};

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code", width: 150 },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "GROUP", value: "category_name" },
  { text: "GROUP CATEGORY", value: "group_category_name" },
  { text: "ITEM", value: "name" },
  { text: "SIZE", value: "size" },
  { text: "IMAGE", value: "image", width: 100 },
  { text: "ACTIONS", value: "action" },
];

const itemStore = useItemStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listItems = ref<any>([]);
const isLoading = ref(false);
const modalShow = ref<any>(false);
let modalInstance: any;
const previewUrl = ref("");

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});

const emptyStateModal = () => {
  modalShow.value = false;
  file_excel.value = null;
};

const { value: file_excel } = useField<any>("file_excel");

const loadDataItems = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await itemStore.dispatchGetItems(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listItems.value = await itemStore.items.items;
    page.value = await itemStore.items.page;
    limit.value = await itemStore.items.pageSize;
    totalItems.value = await itemStore.items.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataItems();
};

const handleEdit = (item: any) => {
  router.push("/management/item/" + item);
};

const handleVarian = (item: any) => {
  router.push("/management/varian/create/" + item);
};

const handleDelete = async (item: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${item.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await itemStore.dispatchDelete(item.id);
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataItems();
        } else {
          toast.error(message);
        }
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

const validationSchema = toTypedSchema(
  zod.object({
    // file_excel: zod.instanceof(File)
    //             .refine(
    //               (file) =>
    //                 [
    //                   "application/vnd.ms-excel",
    //                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //                 ].includes(file.type),
    //               { message: "Invalid document file type" }
    //             ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const submitFileImport = handleSubmit(async (values) => {
  isLoading.value = true;
  const formData = new FormData();
  formData.append("file_excel", file_excel.value);

  const responseApi = await itemStore.dispatchImport(formData);
  const { success, message } = responseApi;
  if (success == true) {
    isLoading.value = false;
    modalShow.value = false;
    toast.success(
      "Data Successfully Uploaded"
    );
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const downloadFormatImport = async () => {
  axios({
        url: `${process.env.VUE_APP_API_BASE_URL}api/goods/download-import-format`, // Replace with your API endpoint
        method: 'GET',
        responseType: 'blob', // Important: Set responseType to 'blob' to receive binary data
      })
          .then(response => {
            isLoading.value = false;
            modalShow.value = false;
            toast.success(
              "Import Format Successfully Downloaded"
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `goods-import-format.xlsx`); // Set desired filename here
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(err => {
            isLoading.value = false;
            toast.error(err.message);
            console.error('Error downloading Excel file:', err);
          });
};

onMounted(() => {
  setTimeout(() => {
    const modalEl = document.getElementById("modalImport");
    if (modalEl) {
      const bootstrap = (window as any).bootstrap;
      modalInstance = new bootstrap.Modal(modalEl);
    }
  }, 1000);
});


loadDataItems();

const setFile = (file) => {
  previewUrl.value = "";
  file_excel.value = file;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "mb-0" }, "List Data Item", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_unref(hasAccess)('goods-create'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: "btn btn-success text-white py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (modalShow.value = true))
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                      _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                      _createElementVNode("span", null, "Import Item")
                    ], -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            (linkAdd != null && _unref(hasAccess)('goods-create'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("a", {
                    class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
                    href: linkAdd?.url
                  }, [
                    _createElementVNode("span", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(linkAdd?.text), 1)
                    ])
                  ], 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(ItemFilter, {
          link: linkAdd,
          onSearchByQuery: loadDataItems
        }),
        _createElementVNode("div", _hoisted_9, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
                key: 1,
                headers: headers,
                items: listItems.value,
                "show-index": "",
                "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
                "server-items-length": totalItems.value,
                "onUpdate:serverOptions": handleServerOptionsUpdate,
                "buttons-pagination": ""
              }, {
                "item-image": _withCtx((props) => [
                  _createElementVNode("img", {
                    src: props.image_link,
                    alt: "image-link",
                    class: "image-item"
                  }, null, 8, _hoisted_10)
                ]),
                "item-action": _withCtx((props) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", {
                      class: "material-symbols-outlined cursor-pointer",
                      onClick: ($event: any) => (handleVarian(props.id))
                    }, " dynamic_feed ", 8, _hoisted_12),
                    (_unref(hasAccess)('goods-update'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "material-symbols-outlined cursor-pointer",
                          onClick: ($event: any) => (handleEdit(props.id))
                        }, " edit ", 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    (_unref(hasAccess)('goods-delete'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "material-symbols-outlined cursor-pointer",
                          onClick: ($event: any) => (handleDelete(props))
                        }, " delete ", 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["items", "server-options", "server-items-length"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(CustomSizeLoading, {
              key: 0,
              text: "Uploading Data...",
              size: 50
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[5] || (_cache[5] = _createElementVNode("h5", {
              class: "modal-title",
              id: "modalImportLabel"
            }, "Import Item from Excel", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: emptyStateModal
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(submitFileImport) && _unref(submitFileImport)(...args))),
            class: ""
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "qty",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("File Import "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(ExcelUploader, { onFileResult: setFile })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "modal-footer d-flex justify-content-between align-items-center" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success text-white",
                onClick: downloadFormatImport
              }, " Download Format Import "),
              _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-3" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: emptyStateModal
                }, " Close "),
                _cache[7] || (_cache[7] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, " Submit ", -1))
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}
}

})